import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _, { isInteger } from "lodash";
import { getRandomJokes } from "shared/api/jokes";

import Socket from "socket";
import useSound from "use-sound";
import { AnimatePresence } from "framer-motion/dist/framer-motion";
import CTDiceRollResult from "./screens/CTDiceRollResult";
import CTjoining from "./screens/CTjoining";
import CTOver from "./screens/CTOver";
import CTQuestion from "./screens/CTQuestion";
import CTStartTurn from "./screens/CTStartTurn";
import CTTurnResult from "./screens/CTTurnResult";
import {
  set_ct_selected_player,
  set_ct_selected_card,
  set_ct_steal_button,
  set_ct_dice_special6
} from "redux/game/action";
const CT = () => {
  const {
    gameReducer: {
      currentUser,
      ct_selected_player,
      ct_selected_card,
      ct_steal_button,
      ct_dice_special6,
      roomObj: {
        users,
        id,
        game_state: {
          status,
          dice,
          active_player,
          reader,
          discard_pile = [],
          player_status = [],
          chosen_answer,
          cover_up,
          question: { answers, category, correct_answer, prompt } = {}
        } = {}
      }
    },
    paramsReducer: {gameObj,
      paramsObj: { game_api_stage ,default_audio_effect
      }
    }
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [buzzer_sound] = useSound(default_audio_effect);
  const [joke, setJoke] = useState("Loading...");
  const [dice1, setdice1] = useState("");
  const [dice2, setdice2] = useState("");
  const currentPlayer = users?.find(
    (user) => user.user_id === currentUser?.userId
  );
  const isActivePlayer = currentPlayer?.player_id === active_player;
  const isReaderPlayer = currentPlayer?.player_id === reader;
  const OtherPlayers = player_status?.filter(
    (item) => item.id !== active_player
  );
  const diceSpecial = dice?.dice_special || 0;

  const winnerId = player_status?.find((player) => {
    const values = Object.values(player.cards);
    const isWinner =
      values.every((value) => value >= 1) ||
      values.filter((value) => value >= 3).length >= 1;
    return isWinner;
  })?.id;
  const winner = users?.find((player) => player.player_id === winnerId);
  const nonWinnerPlayers = users?.filter(
    (player) => player.player_id !== winnerId
  );
  const playersWithCard = OtherPlayers?.filter((player) =>
    Object.values(player.cards).some((value) => value > 0)
  );

  const playersWithCardInfo = playersWithCard?.map((card) => {
    const user = users.find((user) => user.player_id === card.id);
    return {
      ...card,
      display_name: user.display_name,
      profile_image: user.profile_image
    };
  });

  const currentPlayerCard = player_status?.find(
    (item) => item.id === currentPlayer.player_id
  );
  const isIntegerBetween0and7 = (val) => {
    val = parseInt(val, 10);
    return isInteger(val) && 1 <= val && val <= 6;
  };
  const RollDiceAction = () => {
    const data = {
      action: "roll-dice",
      roomId: id,
      playerId: currentPlayer?.player_id,
      special: "Regular"
    };
    if (isIntegerBetween0and7(dice1) && isIntegerBetween0and7(dice2)) {
      data.die = [parseInt(dice1), parseInt(dice2)];
    }
    Socket.sendMessage(data);
  };

  const handleRollDiceClick = useCallback(
    _.debounce(() => RollDiceAction(), 1000, {
      leading: true,
      trailing: false
    }),
    [id, currentPlayer, dice1, dice2]
  );

  const handlePlayerCardEmpty = () => {
    dispatch(set_ct_selected_card(""));
    dispatch(set_ct_selected_player(null));
    dispatch(set_ct_steal_button(false));
    set_ct_dice_special6(false);
  };
  useEffect(() => {
    return () => {
      handlePlayerCardEmpty();
    };
  }, [status]);
  useEffect(() => {
    getRandomJokes().then((data) => setJoke(data));
  }, [status]);


  return (
    <div className="ct-main">
      <AnimatePresence exitBeforeEnter>
        <div className="ct-content">
          {status === "Joining" && <CTjoining key="CT_0" users={users}  screens={gameObj}/>}
          {status === "StartTurn" && (
            <CTStartTurn
              key="CT_1"
              joke={joke}
              screens={gameObj}
              handleRollDiceClick={handleRollDiceClick}
              isActivePlayer={isActivePlayer}
              setdice1={setdice1}
              setdice2={setdice2}
              dice1={dice1}
              dice2={dice2}
              currentPlayerCard={currentPlayerCard}
              currentPlayer={currentPlayer}
              isTestingStage={game_api_stage === "apptest"}
              buzzer_sound={buzzer_sound}
              default_audio_effect={default_audio_effect}
            />
          )}
          {status === "DiceRollResult" && (
            <CTDiceRollResult
              key={`CT_2 ${
                ct_selected_player != null
                  ? "CT_2.2"
                  : ct_selected_card != ""
                  ? "CT_2.2.2"
                  : diceSpecial != null
                  ? "CT_2.2.2.2"
                  : ""
              }`}
              joke={joke}
              screens={gameObj}
              isActivePlayer={isActivePlayer}
              diceData={dice}
              roomId={id}
              currentPlayer={currentPlayer}
              discard_pile={discard_pile}
              OtherPlayers={OtherPlayers}
              CoverUpData={cover_up}
              currentPlayerCard={currentPlayerCard}
              playersWithCard={playersWithCard}
              playersWithCardInfo={playersWithCardInfo}
              playerSelected={ct_selected_player}
              cardSelected={ct_selected_card}
              stealButton={ct_steal_button}
              showCardList={ct_dice_special6}
              buzzer_sound={buzzer_sound}
              default_audio_effect={default_audio_effect}

            />
          )}
          {status === "Question" && (
            <CTQuestion
              key="CT_3"
              screens={gameObj}
              roomId={id}
              isActivePlayer={isActivePlayer}
              isReaderPlayer={isReaderPlayer}
              answers={answers}
              category={category}
              correct_answer={correct_answer}
              question={prompt}
              currentPlayer={currentPlayer}
              dicedata={dice}
              buzzer_sound={buzzer_sound}
              default_audio_effect={default_audio_effect}

            />
          )}
          {status === "TurnResult" && (
            <CTTurnResult
              key="CT_4"
              roomId={id}
              screens={gameObj}
              dicedata={dice}
              isActivePlayer={isActivePlayer}
              isReaderPlayer={isReaderPlayer}
              correct_answer={correct_answer}
              currentPlayer={currentPlayer}
              category={category}
              question={prompt}
              answers={answers}
              chosen_answer={chosen_answer}
              correctlyAnswered={chosen_answer === correct_answer}
              buzzer_sound={buzzer_sound}
              default_audio_effect={default_audio_effect}
            />
          )}
          {status === "Over" && (
            <CTOver
              key="CT_5"
              screens={gameObj}
              winnerPlayer={winner}
              nonWinner={nonWinnerPlayers}
            />
          )}
        </div>
      </AnimatePresence>
    </div>
  );
};

export default CT;
